export default {
  $ID: 'Baseline',
  Name: 'Baseline',
  Model: {
    '$ID': 'layout1',
    '$Type': 'dr-simple-layout',
    'Widgets': [
      {
        '$Type': 'dr-toolbar',
        '$ID': '0.14977850569251205',
        'Title': '',
        'Color': 'accent',
        'DarkMode': false,
        'Collapse': false,
        'Dense': false,
        'Extended': false,
        'Flat': false,
        'Prominent': false,
        'Short': false,
        'Widgets': [
          {
            '$Type': 'dr-layout-placeholder',
            'Name': 'toolbar'
          }
        ]
      },
      {
        '$Type': 'dr-navigation',
        '$ID': '0.9285059937739462',
        'DarkMode': false,
        'ExpandOnHover': false,
        'MiniVariant': false,
        'Color': 'accent',
        'Widgets': [
          {
            '$Type': 'dr-layout-placeholder',
            'Name': 'navigation'
          }
        ]
      },
      {
        '$Type': 'dr-layout-placeholder',
        'Name': 'Main'
      }
    ]
  },
  LayoutType: ['responsive']
}